import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { BlockTemplateComponent } from 'src/app/components/block-template/block-template/block-template.component';
import { BoletoService } from '../../../../../api/module/erp/services/boleto/boleto.service';
 
@Component({
  selector: 'app-area-cliente',
  templateUrl: './area-cliente.component.html',
  styleUrls: ['./area-cliente.component.scss']
})
export class AreaClienteComponent implements OnInit {
  @BlockUI() public blockUI!: NgBlockUI;
  blockTemplate: BlockTemplateComponent | undefined;
  numDocumento = "";
  isExistBoleto: boolean = true;
  isResultado: boolean = false;
  result: any;
  listaBloquete: any;
 
  constructor(private toastr: ToastrService, private boletoService: BoletoService,
     ) { }
     @ViewChild('strTrancInput', { static: false }) strTrancInput!: ElementRef;

  ngOnInit(): void {
    this.numDocumento = "";
  } 
 
  envia(linkArquivo: string) {
    this.blockUI.start()
    setTimeout(() => { 
      const strTrancElement = this.strTrancInput.nativeElement;
      strTrancElement.value = linkArquivo;
      strTrancElement.form.submit();
      this.numDocumento = "";
      this.blockUI.stop();
       },1000); 
  }
   
  pesquisarDocumento(numDocumento:string ) {
   
    try {
      if (!numDocumento)
    {
      this.toastr.warning("Informe o CPF/CNPJ");
      return;
      }
      this.blockUI.start();

      this.boletoService.getInfoBoleto(numDocumento).subscribe((data) => {
       
        setTimeout(() => {
          if (data.ListadeBloquetos.Bloqueto.length > 0) {
            this.isExistBoleto = true;
            this.isResultado = true;
            this.listaBloquete = data.ListadeBloquetos.Bloqueto;
            this.result = data;
          }

          else {
            this.toastr.warning("CPF/CNPJ não encontrado");
            this.isExistBoleto = false;
            this.isResultado = false;
          }
          this.blockUI.stop();
       },1000); 
        
      });
    }
    catch (error) {
      this.toastr.error("Erro ao processar dados");
      this.blockUI.stop();

    }

    
  } 

}
